import { getApi } from "./api_instance";

export const projectsReport = async ({
  filterData = null,
  page,
  pageSize,
  fromDate,
  toDate,
  dispatch,
}) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/userprojects?toDate=${toDate}&fromDate=${fromDate}&page=${page}&pageSize=${pageSize}&filterData=${filterData}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
